// extracted by mini-css-extract-plugin
export var deliveryRow = "_mm-a";
export var fixedHeight = "_mm-4";
export var freightLogo = "_mm-9";
export var fullWidth = "_mm-3";
export var priceColumn = "_mm-5";
export var radioSelected = "_mm-7";
export var radioUnselected = "_mm-6";
export var selectedOption = "_mm-2";
export var selectedOptionContainer = "_mm-1";
export var selection = "_mm-0";
export var tallSkeletonText = "_mm-8";